<!-- Admin / User Settings -->
<div class="user-settings-page mx-auto max-w-6xl px-4 pb-10 pt-6 sm:px-6 text-surface-900 dark:text-surface-0">
  <!-- Header -->
  <div class="mb-6 flex flex-wrap items-center justify-between gap-4">
    <div class="flex items-center gap-3">
      <button
        (click)="home()"
        class="rounded-full border border-surface-200 bg-surface-0 p-2 text-primary shadow-sm transition hover:-translate-y-0.5 dark:border-surface-700 dark:bg-surface-900"
        aria-label="Go Home">
        <i class="pi pi-home !text-2xl sm:!text-3xl"></i>
      </button>
      <div>
        <h1 class="text-2xl font-semibold text-surface-900 sm:text-3xl">User Settings</h1>
        <p class="text-sm text-surface-500">Manage your account, devices, and experience.</p>
      </div>
    </div>
    <div class="flex items-center gap-2 rounded-full border border-surface-200 bg-surface-0 px-4 py-2 text-xs text-surface-600 shadow-sm dark:border-surface-700 dark:bg-surface-900 dark:text-surface-300">
      <span class="inline-flex h-2 w-2 rounded-full" [ngClass]="isOnline ? 'bg-emerald-500' : 'bg-rose-500'"></span>
      <span>{{ isOnline ? 'Online' : 'Offline' }}</span>
    </div>
  </div>

  <div
    class="rounded-3xl border border-surface-200 bg-gradient-to-br from-surface-0 via-surface-50 to-surface-100 p-4 shadow-lg dark:border-surface-700 dark:from-surface-900 dark:via-surface-900 dark:to-surface-800 sm:p-6">
    <p-tabs class="user-settings-tabs" [(value)]="activeTab" (valueChange)="$event !== undefined && onTabValueChange($event)">
      <p-tablist>
        <p-tab value="account">Account settings</p-tab>
        <p-tab value="saved-searches">Saved Search/Filters</p-tab>
        <p-tab value="device">Device settings</p-tab>
        <p-tab value="devices">Device list</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="account">
        <div class="grid gap-6">
          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 text-base font-semibold text-surface-700">Account</div>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
              <div class="flex flex-col">
                <label for="username" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Username</label
                >
                <input
                  id="username"
                  name="username"
                  [value]="(username$ | async) ?? ''"
                  readonly
                  class="rounded-md border border-surface-200 bg-surface-100 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-800 dark:text-surface-100" />
              </div>
              <div class="flex flex-col">
                <label for="displayName" class="mb-1 text-xs font-semibold uppercase 
                    tracking-wide text-surface-500">
                    Display Name
                </label>
                <input
                  id="displayName"
                  name="displayName"
                  [(ngModel)]="displayName"
                  placeholder="Enter display name"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100" />
              </div>
              <div class="flex flex-col md:col-span-2">
                <label for="email" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >E-mail</label
                >
                <input
                  id="email"
                  name="email"
                  type="email"
                  [(ngModel)]="email"
                  placeholder="name@example.com"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100" />
              </div>
            </div>
          </div>

          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 text-base font-semibold text-surface-700">Synchronisation</div>
            <div class="flex flex-col gap-4 md:flex-row md:items-center">
              <div class="flex flex-col md:w-72">
                <label for="syncMethod" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Sync Method</label
                >
                <select
                  id="syncMethod"
                  [(ngModel)]="syncMethod"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100">
                  <option value="Automatic">Automatic</option>
                  <option value="Manual">Manual</option>
                </select>
              </div>
              <div
                class="text-sm"
                [ngClass]="syncMethod === 'Manual' ? 'text-rose-600' : 'text-surface-600'">
                {{ syncMethodDescription }}
              </div>
            </div>
          </div>

          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 text-base font-semibold text-surface-700">Options</div>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
              <div class="flex flex-col gap-2">
                <label class="text-xs font-semibold uppercase tracking-wide text-surface-500">
                  Autosave
                </label>
                <p-togglebutton
                  [(ngModel)]="autosaveEnabled"
                  onLabel="On"
                  offLabel="Off"
                  [style]="{ width: '100%' }"></p-togglebutton>
              </div>
              <div class="flex flex-col gap-2">
                <label class="text-xs font-semibold uppercase tracking-wide text-surface-500">
                  Show Favorites
                </label>
                <p-togglebutton
                  [(ngModel)]="showFavorites"
                  onLabel="On"
                  offLabel="Off"
                  [style]="{ width: '100%' }"></p-togglebutton>
              </div>
              <div class="flex flex-col gap-2">
                <label class="text-xs font-semibold uppercase tracking-wide text-surface-500">
                  Show Recents
                </label>
                <p-togglebutton
                  [(ngModel)]="showRecent"
                  onLabel="On"
                  offLabel="Off"
                  [style]="{ width: '100%' }"></p-togglebutton>
              </div>
              <div class="flex flex-col gap-2">
                <label for="recentDays" class="text-xs font-semibold uppercase tracking-wide text-surface-500">
                  Recent
                </label>
                <p-select
                  inputId="recentDays"
                  [options]="recentDayOptions"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  class="w-full"
                  [(ngModel)]="recentDays">
                </p-select>
              </div>
            </div>
          </div>
        </div>
        </p-tabpanel>

        <!-- Saved Search/Filters Tab -->
        <p-tabpanel value="saved-searches">
        <div class="grid gap-6">
          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 flex items-center justify-between">
              <div class="text-base font-semibold text-surface-700">Saved Search/Filters</div>
              <p *ngIf="!savedSearches || savedSearches.length === 0" class="text-sm text-surface-500">
                No saved searches yet. Save a search/filter from the Home page using the Page menu.
              </p>
            </div>
            
            <div *ngIf="savedSearches && savedSearches.length > 0" class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-surface-200">
                    <th class="px-4 py-2 text-left font-semibold text-surface-700">Name</th>
                    <th class="px-4 py-2 text-left font-semibold text-surface-700">Filter Details</th>
                    <th class="px-4 py-2 text-left font-semibold text-surface-700">Created</th>
                    <th class="px-4 py-2 text-center font-semibold text-surface-700">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let search of savedSearches; let i = index" class="border-b border-surface-100 hover:bg-surface-50">
                    <td class="px-4 py-3 font-medium text-surface-900 dark:text-surface-0">{{ search.name }}</td>
                    <td class="px-4 py-3">
                      <div class="text-xs text-surface-600">
                        <span *ngIf="search.searchString" class="inline-block mr-2 rounded bg-blue-50 px-2 py-1 text-blue-700 dark:bg-blue-500/20 dark:text-blue-200">
                          Search: {{ search.searchString | slice:0:20 }}{{ (search.searchString?.length || 0) > 20 ? '...' : '' }}
                        </span>
                        <span *ngIf="search.tagIds && search.tagIds.length > 0" class="inline-block mr-2 rounded bg-green-50 px-2 py-1 text-green-700 dark:bg-green-500/20 dark:text-green-200">
                          Include Tags: {{ search.tagIds.length }}
                        </span>
                        <span *ngIf="search.tagIncludeMode === 'OR'" class="inline-block mr-2 rounded bg-yellow-50 px-2 py-1 text-yellow-700 dark:bg-yellow-500/20 dark:text-yellow-200">
                          OR mode
                        </span>
                        <span *ngIf="search.excludeTagIds && search.excludeTagIds.length > 0" class="inline-block mr-2 rounded bg-red-50 px-2 py-1 text-red-700 dark:bg-red-500/20 dark:text-red-200">
                          Exclude Tags: {{ search.excludeTagIds.length }}
                        </span>
                        <span *ngIf="search.categories && search.categories.length > 0" class="inline-block mr-2 rounded bg-purple-50 px-2 py-1 text-purple-700 dark:bg-purple-500/20 dark:text-purple-200">
                          Categories: {{ search.categories.length }}
                        </span>
                      </div>
                    </td>
                    <td class="px-4 py-3 text-xs text-surface-500">
                      {{ search.createdAt ? (search.createdAt | date:'short') : 'N/A' }}
                    </td>
                    <td class="px-4 py-3 text-center">
                      <button
                        (click)="activateSavedSearch(i)"
                        class="mr-2 rounded bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 hover:bg-emerald-100">
                        Activate
                      </button>
                      <button
                        (click)="moveSavedSearchUp(i)"
                        [disabled]="i === 0"
                        class="mr-2 rounded bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700 hover:bg-sky-100 disabled:cursor-not-allowed disabled:opacity-40">
                        Up
                      </button>
                      <button
                        (click)="moveSavedSearchDown(i)"
                        [disabled]="i === savedSearches.length - 1"
                        class="mr-2 rounded bg-indigo-50 px-3 py-1 text-xs font-medium text-indigo-700 hover:bg-indigo-100 disabled:cursor-not-allowed disabled:opacity-40">
                        Down
                      </button>
                      <button
                        (click)="renameSavedSearch(i)"
                        class="mr-2 rounded bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700 hover:bg-amber-100">
                        Rename
                      </button>
                      <button
                        (click)="deleteSavedSearch(i)"
                        class="rounded bg-red-50 px-3 py-1 text-xs font-medium text-red-700 hover:bg-red-100">
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        </p-tabpanel>

        <p-tabpanel value="device">
        <div class="grid gap-6">
          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
              <div>
                <div class="text-base font-semibold text-surface-700">Device Info</div>
                <p class="text-xs text-surface-500">Local device identity and label.</p>
              </div>
              <button
                type="button"
                class="rounded-xl border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-700 transition hover:bg-rose-100"
                (click)="deleteDevice(deviceId)"
                [disabled]="!isOnline"
                [ngClass]="!isOnline ? 'opacity-50 cursor-not-allowed' : ''">
                Delete Device
              </button>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div class="flex flex-col">
                <label for="deviceLabel" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Device Label</label
                >
                <input
                  id="deviceLabel"
                  name="deviceLabel"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100"
                  [(ngModel)]="deviceLabel" />
              </div>
              <div class="flex flex-col">
                <div class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500">Device ID</div>
                <div class="rounded-md border border-surface-200 bg-surface-100 p-2 text-sm text-surface-700 dark:border-surface-700 dark:bg-surface-800 dark:text-surface-100">
                  {{ deviceId || deviceService.getOrCreateDeviceId() }}
                </div>
              </div>
            </div>
          </div>

          <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
            <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
              <div>
                <div class="text-base font-semibold text-surface-700">User Interface</div>
                <p class="text-xs text-surface-500">Theme, zoom, and layout preferences.</p>
              </div>
              <div class="flex items-center gap-2">
                <div class="flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-xs font-semibold text-primary">
                  <span class="inline-flex h-3 w-3 rounded-full border border-white/60" style="background: var(--p-primary-color, var(--primary-color, #3b82f6));"></span>
                  <span>{{ selectedPrimaryColor() || 'default' }}</span>
                </div>
                <button
                  type="button"
                  class="flex h-9 w-9 items-center justify-center rounded-full border border-surface-200 bg-surface-0 text-surface-700 shadow-sm transition hover:-translate-y-0.5 dark:border-surface-700 dark:bg-surface-800 dark:text-surface-200"
                  (click)="toggleDarkMode()"
                  aria-label="Toggle dark mode">
                  <i class="pi" [ngClass]="{ 'pi-moon': isDarkMode(), 'pi-sun': !isDarkMode() }"></i>
                </button>
                <div class="relative inline-block">
                  <p-button icon="pi pi-palette" (click)="pop.toggle($event)" aria-label="Theme settings"></p-button>
                  <p-popover #pop [dismissable]="true" appendTo="body">
                    <app-config></app-config>
                  </p-popover>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
              <div class="flex flex-col">
                <label for="themeSelect" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Theme</label
                >
                <select
                  id="themeSelect"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100"
                  [(ngModel)]="selectedTheme"
                  (change)="onThemeChange($event)">
                  <option *ngFor="let theme of availableThemes" [value]="theme">{{ theme }}</option>
                </select>
              </div>

              <div class="flex flex-col">
                <label for="homeView" class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Home View</label
                >
                <select
                  id="homeView"
                  class="rounded-md border border-surface-200 bg-surface-0 p-2 text-surface-700 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-100"
                  [(ngModel)]="homeView"
                  (change)="onThemeChange($event)">
                  <option *ngFor="let view of availableHomeViews" [value]="view">{{ view }}</option>
                </select>
              </div>

              <div class="flex flex-col">
                <label class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >System Zoom ({{ systemZoomFactor }}%)</label
                >
                <p-slider
                  [(ngModel)]="systemZoomFactor"
                  [min]="50"
                  [max]="400"
                  [step]="1"
                  [style]="{ width: '100%' }"
                  (onChange)="onZoomFactorChange('system',$event)"></p-slider>
              </div>

              <div class="flex flex-col">
                <label class="mb-1 text-xs font-semibold uppercase tracking-wide text-surface-500"
                  >Editor Zoom ({{ editorZoomFactor }}%)</label
                >
                <p-slider
                  [(ngModel)]="editorZoomFactor"
                  [min]="50"
                  [max]="400"
                  [step]="1"
                  [style]="{ width: '100%' }"
                  (onChange)="onZoomFactorChange('editor',$event)"></p-slider>
              </div>
            </div>
          </div>
        </div>
        </p-tabpanel>

        <p-tabpanel value="devices">
        <div class="rounded-2xl border border-surface-200 bg-surface-0 p-5 shadow-sm dark:border-surface-700 dark:bg-surface-900">
          <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
            <div>
              <div class="text-base font-semibold text-surface-700">My Devices</div>
              <p class="text-xs text-surface-500">All devices linked to your account.</p>
            </div>
            <p-button
              icon="pi pi-refresh"
              label="Refresh"
              (click)="loadDevices()"
              [disabled]="!isOnline"></p-button>
          </div>

          <div *ngIf="!isOnline" class="rounded-xl border border-dashed border-surface-200 bg-surface-50 p-4 text-sm text-surface-500">
            You are offline. Connect to refresh your device list.
          </div>

          <div *ngIf="isOnline" class="overflow-x-auto">
            <table class="min-w-full border border-surface-200 text-sm dark:border-surface-700">
              <thead class="bg-surface-100 text-xs uppercase tracking-wide text-surface-500">
                <tr>
                  <th class="px-3 py-2 text-left">ID</th>
                  <th class="px-3 py-2 text-left">Label</th>
                  <th class="px-3 py-2 text-left">Created</th>
                  <th class="px-3 py-2 text-left">Last Seen</th>
                  <th class="px-3 py-2 text-left">Plattform</th>
                  <th class="px-3 py-2 text-left">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loadingDevices">
                  <td colspan="6" class="px-3 py-4 text-center text-surface-400">Loading devices...</td>
                </tr>
                <tr *ngFor="let device of devices" class="border-t border-surface-200 dark:border-surface-700">
                  <td class="px-3 py-2 font-mono text-xs text-surface-600">{{ device._id }}</td>
                  <td class="px-3 py-2 text-xs text-surface-700">{{ device.label }}</td>
                  <td class="px-3 py-2 text-xs text-surface-700">{{ device.created_on | date : 'short' }}</td>
                  <td class="px-3 py-2 text-xs text-surface-700">{{ device.last_modified | date : 'short' }}</td>
                  <td class="px-3 py-2 text-xs text-surface-700">{{ device.description || '-' }}</td>
                  <td class="px-3 py-2 text-xs">
                    <button
                      class="rounded-md bg-rose-50 px-2 py-1 text-xs font-semibold text-rose-700 transition hover:bg-rose-100"
                      (click)="deleteDevice(device._id)">
                      Delete
                    </button>
                  </td>
                </tr>
                <tr *ngIf="!loadingDevices && devices.length === 0">
                  <td colspan="6" class="px-3 py-4 text-center text-surface-400">No devices found.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <p-button icon="pi pi-save" (click)="saveSettings()" label="Save Settings"></p-button>
      <p-button icon="pi pi-times" (click)="cancel()" label="Cancel" severity="secondary"></p-button>
    </div>
  </div>
</div>
